import React from 'react'
import { withStyles, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';

const style = theme => ({
	root: {
		'&>*': {
			width: `calc(50% - ${theme.spacing(2)}px)`
		},
	}
})

function TransferList({
	classes,
	leftColumn,
	rightColumn
}) {
	return (
		<Grid
			className={classes.root}
			container
			justifyContent='space-between'
		>
			<Grid item>
				{leftColumn}
			</Grid>
			<Grid item>
				{rightColumn}
			</Grid>
		</Grid>
	)
}

TransferList.propTypes = {
	classes: PropTypes.any,
	leftColumn: PropTypes.object,
	rightColumn: PropTypes.object,
}

TransferList.defaultProps = {
}

export default withStyles(style)(TransferList);